const BASE_URL = "https://arthaverse.com";

export const resourcesListSchema = (
  resources: any[]
) => {
  return {
    "@context": "https://schema.org",

    "@graph": [
      {
        "@type": "CollectionPage",

        "@id": `${BASE_URL}/resources`,

        url: `${BASE_URL}/resources`,

        name: "Resources on ArthaVerse",

        description:
          "Explore business videos, company insights, expert interviews, and educational resources on ArthaVerse.",

        isPartOf: {
          "@id": `${BASE_URL}/#website`
        },

        about: {
          "@id": `${BASE_URL}/#organization`
        },

        mainEntity: {
          "@id": `${BASE_URL}/resources#itemlist`
        }
      },

      {
        "@type": "ItemList",

        "@id":
          `${BASE_URL}/resources#itemlist`,

        numberOfItems:
          resources?.length || 0,

        itemListElement:
          resources?.map(
            (
              resource: any,
              index: number
            ) => ({
              "@type": "ListItem",

              position: index + 1,

              item: {
                "@type": "VideoObject",

                "@id":
                  `${BASE_URL}/resources/${resource.uid}`,

                name:
                  resource.data?.title,

                headline:
                  resource.data?.title,

                description:
                  resource.data?.description?.[0]
                    ?.text || "",

                url:
                  `${BASE_URL}/resources/${resource.uid}`,

                thumbnailUrl:
                  resource.data?.thumbnail
                    ?.url,

                uploadDate:
                  resource.first_publication_date,

                dateModified:
                  resource.last_publication_date,

                embedUrl:
                  resource.data?.video_url
                    ?.text,

                keywords:
                  resource.tags?.join(
                    ", "
                  ),

                inLanguage:
                  resource.lang,

                publisher: {
                  "@id":
                    `${BASE_URL}/#organization`
                }
              }
            })
          )
      },

      {
        "@type": "BreadcrumbList",

        itemListElement: [
          {
            "@type": "ListItem",

            position: 1,

            name: "Home",

            item: BASE_URL
          },

          {
            "@type": "ListItem",

            position: 2,

            name: "Resources",

            item:
              `${BASE_URL}/resources`
          }
        ]
      }
    ]
  };
};